import { render, staticRenderFns } from "./Yisq.vue?vue&type=template&id=71cc3f8a&scoped=true"
import script from "./Yisq.vue?vue&type=script&lang=js"
export * from "./Yisq.vue?vue&type=script&lang=js"
import style0 from "./Yisq.vue?vue&type=style&index=0&id=71cc3f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cc3f8a",
  null
  
)

export default component.exports